import {css} from "@panda/css";

import {GalleryOutlineIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    imageUrl: string | null;
    offerName: string;
    planImageUrl: string | null;
    onGalleryClick: () => void;
    onMainImageClick: () => void;
    onPlanClick: () => void;
}

export function TinderMultiLeadGallery({imageUrl, offerName, planImageUrl, onGalleryClick, onMainImageClick, onPlanClick}: IProps) {
    return (
        <div className={galleryStyle}>
            {imageUrl ? (
                <button type="button" className={imageButtonStyle} onClick={onMainImageClick} aria-label="Otwórz galerię zdjęć">
                    <img src={imageUrl} alt={offerName} className={imageStyle} />
                </button>
            ) : (
                <div className={imageFallbackStyle}>
                    <Text variant="info_txt_1" color="var(--colors-gray-600)">
                        Brak zdjęcia
                    </Text>
                </div>
            )}

            <div className={mediaButtonsStyle}>
                {planImageUrl && (
                    <button type="button" className={mediaButtonStyle} onClick={onPlanClick} aria-label="Rzut mieszkania">
                        <PropertyPlanIcon size="3.2" wrapperSize="3.2" fill="var(--colors-secondary)" />
                    </button>
                )}
                <button type="button" className={mediaButtonStyle} onClick={onGalleryClick} aria-label="Galeria zdjęć">
                    <GalleryOutlineIcon size="3.2" wrapperSize="3.2" fill="var(--colors-secondary)" />
                </button>
            </div>
        </div>
    );
}

const galleryStyle = css({
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "var(--colors-gray-100)",
    aspectRatio: "16 / 9",
    mb: 4,
    md: {
        aspectRatio: "auto",
        height: "100%",
        minHeight: 260,
        mb: 0
    }
});

const imageButtonStyle = css({
    position: "absolute",
    inset: 0,
    display: "block",
    width: "100%",
    height: "100%",
    p: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer"
});

const imageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const imageFallbackStyle = css({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const mediaButtonsStyle = css({
    position: "absolute",
    right: 2,
    bottom: 0,
    display: "flex",
    gap: 1.5,
    transform: "translateY(50%)",
    md: {
        bottom: 2,
        transform: "none"
    }
});

const mediaButtonStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    p: 0,
    border: 0,
    borderRadius: "100%",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-white)",
    cursor: "pointer"
});
import {css} from "@panda/css";

import {GalleryOutlineIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    imageUrl: string | null;
    offerName: string;
    planImageUrl: string | null;
    onGalleryClick: () => void;
    onMainImageClick: () => void;
    onPlanClick: () => void;
}

export function TinderMultiLeadGallery({imageUrl, offerName, planImageUrl, onGalleryClick, onMainImageClick, onPlanClick}: IProps) {
    return (
        <div className={galleryStyle}>
            {imageUrl ? (
                <button type="button" className={imageButtonStyle} onClick={onMainImageClick} aria-label="Otwórz galerię zdjęć">
                    <img src={imageUrl} alt={offerName} className={imageStyle} />
                </button>
            ) : (
                <div className={imageFallbackStyle}>
                    <Text variant="info_txt_1" color="var(--colors-gray-600)">
                        Brak zdjęcia
                    </Text>
                </div>
            )}

            <div className={mediaButtonsStyle}>
                {planImageUrl && (
                    <button type="button" className={mediaButtonStyle} onClick={onPlanClick} aria-label="Rzut mieszkania">
                        <PropertyPlanIcon size="3.2" wrapperSize="3.2" fill="var(--colors-secondary)" />
                    </button>
                )}
                <button type="button" className={mediaButtonStyle} onClick={onGalleryClick} aria-label="Galeria zdjęć">
                    <GalleryOutlineIcon size="3.2" wrapperSize="3.2" fill="var(--colors-secondary)" />
                </button>
            </div>
        </div>
    );
}

const galleryStyle = css({
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "var(--colors-gray-100)",
    aspectRatio: "16 / 9",
    mb: 4,
    md: {
        aspectRatio: "auto",
        height: "100%",
        minHeight: 260,
        mb: 0
    }
});

const imageButtonStyle = css({
    position: "absolute",
    inset: 0,
    display: "block",
    width: "100%",
    height: "100%",
    p: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer"
});

const imageStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const imageFallbackStyle = css({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const mediaButtonsStyle = css({
    position: "absolute",
    right: 2,
    bottom: 0,
    display: "flex",
    gap: 1.5,
    transform: "translateY(50%)",
    md: {
        bottom: 2,
        transform: "none"
    }
});

const mediaButtonStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    p: 0,
    border: 0,
    borderRadius: "100%",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-white)",
    cursor: "pointer"
});
